import { useMemo } from 'react';
import { useLocation } from 'react-router';
import type { ChatDetailLocationState } from '../PageChatDetail';

export const useChatDetailLocationState = () => {
  const location = useLocation();

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Location state is controlled internally and follows the expected type.
  const state: ChatDetailLocationState | undefined = location.state;

  return useMemo(() => ({ state }), [state]);
};
